import React, { useRef } from 'react'
import { Animated, PanResponder, StyleSheet } from 'react-native'

import { getCountOfEventsAtEvent, getOrderOfEvent } from '../utils'
import { widthContext } from './CalendarBody'

export interface panXY {
  _value: number
}
export interface panType {
  x: any
  y: any
  setOffset: any
  flattenOffset: any
  setValue: any
}

export const Draggable = (props) => {
  const pan: panType = useRef(new Animated.ValueXY()).current
  var cellWidth = React.useContext(widthContext).calculatedWidth
  const cellHeight = 1000 / 24
  const isDayMode = Object.keys(props.dateRange).length == 1

  let panResponder
  panResponder = useRef(
    PanResponder.create({
      onMoveShouldSetPanResponder: () => true,
      onPanResponderGrant: (_e, _gestureState) => {
        props.setDragging(true)
        pan.setOffset({
          x: pan.x._value,
          y: pan.y._value,
        })
      },
      onPanResponderMove: Animated.event([null, { dx: pan.x, dy: pan.y }], {
        useNativeDriver: false,
      }),
      onPanResponderRelease: (_e, gestureState) => {
        props.setDragging(false)
        let xUnit, xUnits, xDif
        if (isDayMode) {
          xUnits = 0
          xUnit = 0
        } else {
          xUnit = (cellWidth - 50) / 7
          xDif = gestureState.moveX - gestureState.x0
          xUnits = Math.floor(xDif / xUnit + 0.5)
        }

        const yUnit = cellHeight
        const yDif = gestureState.moveY - gestureState.y0
        var yUnits = Math.floor((4 * yDif) / yUnit + 0.5)
        yUnits = yUnits / 4
        pan.setValue({ x: xUnits * xUnit, y: yUnit * yUnits })
        pan.flattenOffset()
        const change = { day: xUnits, hour: yUnits, event: props.event }
        props.moveCallBack(change)
      },
    }),
  ).current

  const day = props.touchableOpacityProps.key.substring(0, 2)
  const days = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su']
  const dayDif = days.indexOf(day)
  const marginLeftInPercent = dayDif * 14.28
  const minusLeft = dayDif * 7.14
  var widthCss = 0.1428 * cellWidth - 9.14
  var leftCellCss = (marginLeftInPercent * cellWidth) / 100 - minusLeft

  if (isDayMode) {
    widthCss = widthCss * 7 + 15
    leftCellCss = 0
  }
  
  const numberOfThisTimeEvent = getCountOfEventsAtEvent(props.event, props.events)
  var marginLeftInCell =
    (getOrderOfEvent(props.event, props.events) * widthCss) / numberOfThisTimeEvent
  widthCss = widthCss / numberOfThisTimeEvent - 3


  const isDone = props.event.task ? props.event.task.activity?.status == 'Done' : false

  return (
    <>
      <Animated.View
        style={[
          (props.touchableOpacityProps && props.touchableOpacityProps.style) || styles.box,
          {
            marginLeft: leftCellCss + marginLeftInCell + 2,
            width: widthCss,
            transform: [{ translateX: pan.x }, { translateY: pan.y }],
            backgroundColor:  props.event.color,
            borderWidth: 0,
            borderStyle: (isDone && 'dashed') || 'solid',
            // borderColor: '#2E2E2E',
            elevation: 0,
          },
        ]}
        {...(panResponder.panHandlers ? panResponder.panHandlers : null)}
      >
        {props.children}
      </Animated.View>
    </>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  titleText: {
    fontSize: 14,
    lineHeight: 24,
    fontWeight: 'bold',
  },
  box: {
    height: 100,
    width: 100,
    backgroundColor: 'blue',
    borderRadius: 5,
  },
})
